@if (hasError) {
    <div class="sh-card-table-wrapper">
        <table class="sh-card-table">
            <thead>
                <th scope="col"></th>
            </thead>
            <tbody>
                <tr id="generic-grid-error-row" class="sh-card-table__row--error">
                    <td style="width: 2000vw">{{ loadingFailedMsg }}</td>
                </tr>
            </tbody>
        </table>
    </div>
}

<sh-records-map style="height: 600px; margin: 16px 0" [records]="mapElements" [actionGroups]="actionItems"> </sh-records-map>
